// @ts-nocheck

import React, { useRef, useCallback, useEffect } from 'react';
import type { ElementRef } from 'react';
import styled from 'styled-components';

import { OrdenacienJuego } from '../../assets/img/mobile';
import diversionLogoUrl from '../../assets/img/mobile/diversion.png';
import juegaResponsibilidadLogoUrl from '../../assets/img/mobile/juega.png';
import jugadoresJuegoResponsableLogoUrl from '../../assets/img/mobile/jugadores-juego-responsable.png';
import jugarBienLogoUrl from '../../assets/img/mobile/jugarbien.png';
import config from '../../config/app.config';
import { __, getLang } from '../../i18n/l10n';
import theme from '../../styled-components/dark';

const Wrapper = styled.div`
  font-size: 0.65em;
  font-family: 'BettingArchivoNarrow';
  padding: 1em;
  line-height: normal;
  color: ${theme.Legal.color};
`;

const Logos = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-grow: 1;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const JuegaResponsibilidadLogo = styled.div`
  background-image: url(${juegaResponsibilidadLogoUrl});
  background-size: 100%;
  background-repeat: no-repeat;
  width: 11.875em;
  max-width: 190px;
  height: 2.5em;
  max-height: 40px;
`;

const DiversionLogo = styled.div`
  background-image: url(${diversionLogoUrl});
  background-size: 100%;
  background-repeat: no-repeat;
  width: 9.375em;
  max-width: 150px;
  height: 1.875em;
  max-height: 30px;
`;

const JugarBienLogo = styled.div`
  background-image: url(${jugarBienLogoUrl});
  background-repeat: no-repeat;
  background-size: contain;
  width: 8.125em;
  max-width: 130px;
  height: 2.5em;
  max-height: 40px;
`;

const JugadoresJuegoResponsableLogo = styled.div`
  background: url(${jugadoresJuegoResponsableLogoUrl}) no-repeat;
  height: 40px;
  width: 40px;
`;

const OrdonacienJuegoLogo = styled(OrdenacienJuego)`
  width: 3.4375em;
  max-width: 55px;
  height: 3.4375em;
  max-height: 55px;
`;

const StyledLink = styled.a`
  && {
    display: block;
    color: ${theme.Legal.color};
    text-decoration: underline;
  }
`;

const LegalText = styled.a`
  && {
    display: block;
    color: ${theme.Legal.color};
  }
`;

const LegalEs = () => {
  const ref = useRef<ElementRef<'div'> | null>(null);

  const onTick = useCallback(() => {
    const div = ref.current;
    if (div) {
      div.innerText = new Date().toTimeString();
    }
  }, []);

  useEffect(() => {
    let interval = setInterval(onTick, 500);
    onTick();

    return () => {
      clearInterval(interval);
      interval = null;
    };
  }, [onTick]);

  return (
    <Wrapper>
      <Logos>
        <Row>
          <LogoWrapper>
            <JuegaResponsibilidadLogo />
          </LogoWrapper>
          <LogoWrapper>
            <DiversionLogo />
          </LogoWrapper>
        </Row>
        <Row>
          <LogoWrapper>
            <JugadoresJuegoResponsableLogo />
          </LogoWrapper>
          <LogoWrapper>
            <OrdonacienJuegoLogo />
          </LogoWrapper>
          <LogoWrapper>
            <JugarBienLogo />
          </LogoWrapper>
        </Row>
      </Logos>
      <p>{__('!desc:DgojLicence')}</p>
      <p>
        <StyledLink
          target="_blank"
          href={`${
            config.webHost[getLang()]
          }/respecto-a-winamax_terminos-y-condiciones-generales_terminos-y-condiciones-generales?external=1`}
        >
          {__('!desc:DgojTerms')}
        </StyledLink>
        <StyledLink
          target="_blank"
          href={`${
            config.webHost[getLang()]
          }/respecto-a-winamax_terminos-y-condiciones-generales_politica-de-privacidad?external=1`}
        >
          {__('!desc:DgojConfidentiality')}
        </StyledLink>{' '}
        <StyledLink
          target="_blank"
          href={`${
            config.webHost[getLang()]
          }/respecto-a-winamax_proteccion-de-los-jugadores_juego-responsable?external=1`}
        >
          {__('!desc:DgojResponsibleGaming')}
        </StyledLink>
      </p>
      <p>
        <LegalText target="_blank" href={`https://fejar.org/?external=1`}>
          {__('!desc:DgojResponsibleGamingTextES')}
        </LegalText>
      </p>
      {/* Clock */}
      <div ref={ref} />
    </Wrapper>
  );
};

export default React.memo<unknown>(LegalEs);
